import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { IActionType, IAxiosResponse } from '../root.types'
import { ActiveSearchTypes, IActionFind, IActionLoad } from './types'
import {
    findActiveSearchFailure,
    findActiveSearchSuccess,
    loadActiveSearchFailure,
    loadActiveSearchSuccess,
    removeActiveSearchFailure,
    removeActiveSearchSuccess,
    rejectActiveSearchFailure,
    rejectActiveSearchSuccess,
    promoteActiveSearchFailure,
    handlePromoteSuccess,
    handlePromoteFailure,
    promoteActiveSearchSuccess
} from './actions'
import { PotentialPatient } from '../../application/models/potential.patient/potentialPatient'
import ActiveSearchService from '../../../services/active.search'
import { open } from '../snack.bar/actions'
import { SnackBarMessageType } from '../../../components/layout/snackbar'
import { push } from 'connected-react-router'

function* loadActiveSearch(action: IActionType<IActionLoad>) {
    try {
        const { paginator } = action.payload

        const activeSearches: IAxiosResponse<PotentialPatient[]> = yield apply(
            ActiveSearchService,
            ActiveSearchService.getAll,
            [paginator]
        )
        yield put(loadActiveSearchSuccess(activeSearches))
    } catch (e) {
        yield put(loadActiveSearchFailure())
        open(
            SnackBarMessageType.ERROR,
            '',
            `Não foi possivel carregar questionários`)
    }
}

function* findActiveSearch(action: IActionType<IActionFind>) {
    try {
        const { activeSearchId } = action.payload
        const activeSearch: IAxiosResponse<PotentialPatient> = yield apply(
            ActiveSearchService,
            ActiveSearchService.getById,
            [activeSearchId]
        )
        yield put<any>(findActiveSearchSuccess(activeSearch))
    } catch (e) {
        yield put(findActiveSearchFailure())
        open(
            SnackBarMessageType.ERROR,
            '',
            `Erro buscar questionário`)

    }
}

function* removeActiveSearch(action: IActionType<IActionFind>) {
    try {
        const { activeSearchId } = action.payload
        yield apply(
            ActiveSearchService,
            ActiveSearchService.remove,
            [activeSearchId]
        )
        yield put<any>(removeActiveSearchSuccess(activeSearchId))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Questionário removido com sucesso`)
        )
    } catch (e) {
        yield put(removeActiveSearchFailure())
        yield put(
            open(
                SnackBarMessageType.ERROR,
                '',
                `Erro ao remover questionário`)
        )
    }
}

function* rejectActiveSearch(action: IActionType<IActionFind>) {
    try {
        const { activeSearchId } = action.payload
        yield apply(
            ActiveSearchService,
            ActiveSearchService.reject,
            [activeSearchId]
        )
        yield put<any>(rejectActiveSearchSuccess(activeSearchId))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Questionário rejeitado com sucesso`)
        )
    } catch (e) {
        yield put(rejectActiveSearchFailure())
        yield put(
            open(
                SnackBarMessageType.ERROR,
                '',
                `Erro ao rejeitado questionário`)
        )
    }
}

function* promotePatient(action: IActionType<{ activeSearchId: string }>) {
    try {
        const { activeSearchId } = action.payload

        yield apply(
            ActiveSearchService,
            ActiveSearchService.promote,
            [activeSearchId]
        )
        yield put<any>(promoteActiveSearchSuccess(activeSearchId))


    } catch (e: any) {
        if (e.code === 409) {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    'Erro ao salvar paciente',
                    `CPF já registrado no sistema`)
            )
        }
        else {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    '',
                    `Erro ao promover paciente`)
            )
        }
        yield put(promoteActiveSearchFailure())
    }
}

function* handlePromote(action: IActionType<{ activeSearch: PotentialPatient }>) {
    try {
        const { activeSearch } = action.payload

        yield put<any>(handlePromoteSuccess(activeSearch))
        yield put(push(`/app/home/register`))

    } catch (e: any) {

        yield put(
            open(
                SnackBarMessageType.ERROR,
                '',
                `Erro ao transferir potencial paciente`)
        )

        yield put(handlePromoteFailure())
    }
}

export default function* ActiveSearchSaga() {
    return yield all([
        takeLatest(ActiveSearchTypes.LOAD_ACTIVESEARCH_REQUEST, loadActiveSearch),
        takeLatest(ActiveSearchTypes.FIND_ACTIVESEARCH_REQUEST, findActiveSearch),
        takeLatest(ActiveSearchTypes.REMOVE_ACTIVESEARCH_REQUEST, removeActiveSearch),
        takeLatest(ActiveSearchTypes.REJECT_ACTIVESEARCH_REQUEST, rejectActiveSearch),
        takeLatest(ActiveSearchTypes.PROMOTE_ACTIVESEARCH_REQUEST, promotePatient),
        takeLatest(ActiveSearchTypes.HANDLE_PROMOTE_REQUEST, handlePromote),
    ])
}